<template>
  <div class="custom-form-wrapper mb-5">
    <h3 class="text-center mb-4">Create Custom Form</h3>
    <div class="mb-3">
      <VueSelect
        label="form_key"
        :reduce="form => form.form_key"
        :options="formSchemas"
        placeholder="Select a form template"
        @input="handleChange"
      />
      <!-- <label>
        Form Selection
        <select v-model="formSchemaKey" class="ml-2">
          <option disabled selected>Make a Selection</option>
          <option
            v-for="(schema, i) in formSchemas"
            :key="i"
            :value="schema.form_key"
            >{{ schema.form_key }}</option
          >
          <option value="new_form">Create a new form</option>
        </select>
      </label> -->
    </div>
    <div class="custom-form-schema">
      <input
        v-model="formKey"
        style=" height: 34px;border: 1px solid rgba(60,60,60,.26); border-radius: 4px;"
        class="mb-3"
        placeholder="Form Key : Start with form-schema- ~ e.g form-schema-mlrit-v1"
      />
      <input
        v-model="formHeading"
        style=" height: 34px;border: 1px solid rgba(60,60,60,.26); border-radius: 4px;"
        class="mb-3"
        placeholder="Form Heading"
      />
      <textarea
        v-model="adminSchema"
        placeholder="Form Schema JSON - Only add schema input"
        style="border-radius: 4px;"
      />
    </div>
    <div class="flex flex-col mt-4">
      <div class="mb-4">
        <div>Preview/Validate</div>
        <div
          style=" height: auto;border: 1px solid rgba(60,60,60,.26); border-radius: 4px;"
        >
          <DetailsForm ref="detailsForm" :admin="true" />
        </div>
      </div>
      <div
        class="relative w-full sm:w-4/5 md:w-3/5 lg:w-3/5 flex justify-center items-center ml-auto mr-auto"
      >
        <button class="custom-form-btn" @click="validateForm">
          Validate Form
        </button>
        <button class="custom-form-btn ml-4" @click="createForm">
          Create Form
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import DetailsForm from "@edyst/shared-components/src/components/DetailsForm"
import VueSelect from "vue-select"
import siteConfig from "@/utils/siteConfig"

export default {
  components: {
    DetailsForm,
    VueSelect,
  },
  data() {
    return {
      adminSchema: "",
      formHeading: "",
      formKey: "",
      formSchemas: [],
      formSchemaKey: "",
    }
  },
  watch: {
    formHeading(newVal) {
      this.$refs.detailsForm.heading = newVal
    },
    adminSchema(newVal) {
      try {
        this.$refs.detailsForm.schema = newVal ? JSON.parse(newVal) : {}
      } catch (error) {
        console.error(error)
      }
    },
    formSchemaKey(newVal) {
      if (!newVal) {
        this.formKey = ""
        this.adminSchema = ""
        this.formHeading = ""
        return
      }
      const form = this.formSchemas.filter(schema => schema.form_key === newVal)
      this.adminSchema = JSON.stringify(form[0].schema, null, "\t")
      this.formHeading = form[0].heading || ""
    },
  },
  async mounted() {
    await this.getFormSchemas()
  },
  methods: {
    handleChange(option) {
      this.formSchemaKey = option ? option.form_key : ""
    },
    async getFormSchemas() {
      const formKeys = await this.getFromKeys()
      const promiser = []
      formKeys.forEach(key => {
        promiser.push(
          fetch(`${siteConfig.siteURL}content/${key}`).then(j => j.json())
        )
      })
      const schemas = await Promise.all(promiser)

      schemas.forEach((schema, idx) => {
        this.formSchemas.push({
          form_key: formKeys[idx],
          schema: schema.schema,
          heading: schema.heading,
        })
      })
    },
    getFromKeys() {
      return this.axios({
        method: "get",
        url: `${siteConfig.siteURL}content`,
      }).then(res => res.data.filter(item => item.startsWith("form-schema-")))
    },
    async fetchSchema(key) {
      const response = await this.axios({
        method: "get",
        url: `${siteConfig.siteURL}/content/${key}`,
      })
      return response
    },
    validateFormKey() {
      if (this.formKey.startsWith("form-schema-") && this.formKey.length > 12) {
        return true
      }
      this.$noty.error("Form key must start with form-schema-", {
        layout: "topRight",
        theme: "relax",
      })
      return false
    },
    validateForm() {
      const { heading, schema } = this.$refs.detailsForm
      if (!heading || !schema || !this.validateFormKey()) {
        this.$noty.error("Please check that all the fields are filled", {
          layout: "topRight",
          theme: "relax",
        })
      }
      this.$refs.detailsForm.validateForm()
    },
    createForm() {
      const { heading, schema } = this.$refs.detailsForm
      if (!heading || !schema || !this.validateFormKey()) {
        this.$noty.error("Please check that all the fields are filled", {
          layout: "topRight",
          theme: "relax",
        })
        return
      }
      const payload = {}

      try {
        payload.heading = this.formHeading
        payload.schema = JSON.parse(this.adminSchema)
      } catch (error) {
        this.$noty.error("Failed to create user form!", {
          layout: "topRight",
          theme: "relax",
        })
        return
      }
      this.axios({
        method: "post",
        url: `${siteConfig.siteURL}content/${this.formKey}`,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "x-access-token": localStorage.token,
        },
        data: payload,
      })
        .then(() => {
          this.$noty.success("Successfully created user form!", {
            layout: "topRight",
            theme: "relax",
          })
        })
        .catch(() => {
          this.$noty.error("Failed to create user form!", {
            layout: "topRight",
            theme: "relax",
          })
        })
    },
  },
}
</script>

<style>
.custom-form-wrapper {
  max-width: 800px;
  margin-right: auto;
  margin-left: auto;
}
.custom-form-schema input {
  width: 100%;
  padding-left: 20px;
}
.custom-form-schema textarea {
  width: 100%;
  height: 400px;
  padding: 20px;
  border: 1px solid #cccccc;
}

.custom-form-btn {
  padding: 10px 15px;
  border-radius: 5px;
  color: #000;
  background: #cccccc;
  font-weight: 700;
}
</style>
